module.exports = __webpack_public_path__ + "img/care-for-kids-logo.469b6a5b.png";